import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import BusinessRestServices from '../../services/business-rest.service';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import CategoryService from '../../services/category.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import RoutingService from '../../services/routing.service';

@Component({
	standalone: true,
	selector: 'limits',
	templateUrl: './limits.component.html',
	imports: [ CommonModule, TranslatePipe, LoaderOverlayComponent, ItemNotificationComponent, FormsModule ]
})
export default class LimitsView implements OnInit {
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private categoryService: CategoryService = inject(CategoryService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private routingService: RoutingService = inject(RoutingService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.routingService.validateAccess('limits').then(() => {
			this.onResolve();
		});
	}
	
	onResolve() {
		this.vm.user = this.session.getSession().user;
		this.getSettings();
		this.vm.hasInsurance = this.hasInsurance;
		this.vm.getInsuranceWarning = this.getInsuranceWarning;
		if (this.vm.user.origin == 'siffi.com') {
			this.vm.contactEmail = 'contact@siffi.com';
		} else {
			this.vm.contactEmail = 'support@minudoc.ee';
		}
	}
	
	getSettings() {
		this.businessRestServices.getSettings().then((settings) => {
			if (!settings.allowedFields) return this.createStats(settings);
			this.categoryService.getAll().then((categories) => {
				for (var i = 0; i < categories.length; i++) {
					var translatedField: any = categories[i];
					for (var j = 0; j < settings.allowedFields.length; j++) {
						var settingField: any = settings.allowedFields[j];
						if (settingField.field === translatedField.furtherSubcategory) {
							settingField.translation = translatedField.translation;
						}
					}
				}
				this.createStats(settings);
			});
		});
	}
	
	hasInsurance() {
		return this.vm.user && this.vm.user.activeInsurancePolicies && this.vm.user.activeInsurancePolicies.length > 0;
	}
	
	getInsuranceWarning() {
		return this.angularFilterHelperService.translate('Limits.Insurance_Warning');
	}
	
	createStats(settings) {
		var stats: Array<any> = [{
			icon: 'user',
			label: this.angularFilterHelperService.translate('Limits.Allowed_Services'),
			value: settings.allowedFields
				? settings.allowedFields.map((item) => { return item.translation; }).join(', ')
				: this.angularFilterHelperService.translate('Limits.All_Services')
		}];
		
		if (!this.vm.user.service.monthlySubscriptionFee) {
			var employeeLimit;
			var limitLabel;
			if (settings.walletLimitType == 'MONTHLY') {
				limitLabel = this.angularFilterHelperService.translate('Limits.Employee_Monthly_Limit')
				employeeLimit = settings.employeeWalletMaxPerMonth;
			} else if (settings.walletLimitType == 'YEARLY') {
				limitLabel = this.angularFilterHelperService.translate('Limits.Employee_Yearly_Limit')
				employeeLimit = settings.employeeWalletMaxPerYear;
			} else {
				limitLabel = this.angularFilterHelperService.translate('Limits.Employee_Quarterly_Limit')
				employeeLimit = settings.employeeWalletMaxPerQuarter;
			}
			
			stats.push({
				icon: 'pie',
				label: limitLabel,
				value: employeeLimit,
			});
			stats.push({
				icon: 'schedule',
				label: this.angularFilterHelperService.translate('Limits.Monthly_Total_Limit'),
				value: settings.totalMonthlyMax,
			});
		} else {
			stats.push({
				icon: 'funds',
				label: this.angularFilterHelperService.translate('Limits.Monthly_Subscription_Fee'),
				value: this.vm.user.service.monthlySubscriptionFee,
			});
			stats.push({
				icon: 'transaction',
				label: this.angularFilterHelperService.translate('Limits.Monthly_Subscription_Description'),
				value: (this.vm.user.service.monthlySubscriptionDescription || '-').replace('{PERIOD_PLACEHOLDER}', ''),
			});
		}
		
		this.vm.stats = stats;
		this.angularHelperService.createTimer(() => { 
			this.vm.initialized = true;
		}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
	}
	
}